// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_3XNMI","arrow":"_2d6mL","carouselImage":"_1xvs1","arrowLeft":"_3GbfI","arrowRight":"_14f75"};